import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { handleUserResponse } from "../../global/idleTimeModal";
import { IDLE_TIME_MODAL_TEST_IDS } from "./idleTimeModalConstants";

const IdleTimeModal = () => {
  const initalTime = 120000;
  const [countdown, setCountdown] = useState(initalTime);
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );

  const { modalVisible } = useSelector((state) => state.idleTimeModalReducer);
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (modalVisible) {
      const workerCode = `
      let counter = 0;
      setInterval(() => {
       if (counter < 20 * 60 * 1000) {
        counter += 500;
        postMessage(counter);
       }
      }, 500);
    `;
      const blob = new Blob([workerCode]);
      const workerUrl = URL.createObjectURL(blob);
      const myWorker = new Worker(workerUrl);
      myWorker.onmessage = (event) => {
        setCount(event.data);
        setCountdown(initalTime - event.data);
      };
      if (count === initalTime) {
        handleUserResponse(false, activeSession) ;
      }
      return () => {
        myWorker.terminate();
        URL.revokeObjectURL(workerUrl);
      };
    }
  }, [modalVisible, count === initalTime]);

  const formatTime = (ms) => {
    if (ms <= 0) return "0:00";
    const minutes = Math.floor(ms / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  if (!modalVisible) {
    return null;
  }

  return (
    <Modal
      opened={modalVisible}
      closeButton={
        <div
          style={{
            display: "none",
          }}
        ></div>
      }
      surface="light"
      fullScreenDialog={false}
      disableAnimation={false}
      disableOutsideClick={true}
      ariaLabel="Session Timeout Modal"
    >
      <ModalTitle>Session timeout</ModalTitle>
      <ModalBody>
        <p>
          Due to inactivity, your session will be logged out in{" "}
          <b>{formatTime(countdown)}</b>
        </p>

        <p>Would you like to stay logged in?</p>
      </ModalBody>

      <ModalFooter
        buttonData={{
          primary: {
            width: "100%",
            children: "Stay logged in",
            onClick: () => handleUserResponse(true, activeSession),
            "data-testid": IDLE_TIME_MODAL_TEST_IDS.IDLE_TIME_MODAL_STAY_LOGGED_IN_BUTTON,
          },
          close: {
            width: "100%",
            children: "Log out",
            onClick: () => handleUserResponse(false, activeSession),
            "data-testid": IDLE_TIME_MODAL_TEST_IDS.IDLE_TIME_MODAL_LOG_OUT_BUTTON,
          },
        }}
      />
    </Modal>
  );
};

export default IdleTimeModal;
